import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "styled-components";

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.button`
  display: flex;
  justify-content: space-between;
  background: var(--neutral-1, #fff);
  color: white;
  padding-top: 7px;
  padding-bottom: 7px;
  cursor: pointer;
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  width: 120px;
  height: 36px;
  text-align: left;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.56px;
  border-radius: 2px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
`;

const DropdownContent = styled.div`
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  position: absolute;
  background-color: white;
  width: 120px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  z-index: 1;
  text-align: left;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  letter-spacing: -0.56px;
`;

const DropdownItem = styled.div`
  color: black;
  padding: 8px 0px 8px 10px;
  cursor: pointer;
  &:hover {
    background-color: #ddd;
  }
`;

const ArrowIcon = styled.span`
  margin-left: 20px;
  opacity: 0.2;
`;

const Dropdown = ({
  options,
  selectedOption,
  other,
  setOther,
  isOpen,
  setIsOpen,
  setSelectedOption,
  width,
}) => {
  const handleToggle = () => {
    if (other) {
      setIsOpen(!isOpen);
      setOther(false);
    } else {
      setIsOpen(!isOpen);
    }
  };

  const handleItemClick = (item) => {
    setSelectedOption(item);
    setIsOpen(false);
  };

  return (
    <DropdownContainer>
      <DropdownButton onClick={handleToggle} style={{ width: width }}>
        {selectedOption}
        <ArrowIcon>
          <FontAwesomeIcon icon={faChevronDown} />
        </ArrowIcon>
      </DropdownButton>
      <DropdownContent $isOpen={isOpen} style={{ width: width }}>
        {options.map((option) => (
          <DropdownItem key={option} onClick={() => handleItemClick(option)}>
            {option}
          </DropdownItem>
        ))}
      </DropdownContent>
    </DropdownContainer>
  );
};

export default Dropdown;
